export default __webpack_public_path__ + "static/media/university-college-school-building-vector.0142d298.png";